import React from "react";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import { ButtonContainer, DivContainer } from "./Communication.styled";
import emailIcon from "@icons/ic-email.svg";
import phoneIcon from "@icons/ic-phone.svg";
import mobilePhoneIcon from "@icons/ic-mobile-phone.svg";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ContactList.styled";

const Communication = (props) => {
  const { t, data } = props;
  return (
    <>
      {data.status === 1 && (
        <DivBackgroundFullOpacity>
          <ButtonContainer>
            {data?.email !== null && data?.email !== "" && (
              <>
                <DivContainer>
                  <Image
                    src={emailIcon}
                    alt={t("EMAIL")}
                    title={t("EMAIL")}
                    styles={{ width: "18px", marginRight: "3px" }}
                  />
                  {data.email}
                </DivContainer>
                <br></br>
              </>
            )}
            {data?.mobilePhone !== null && data?.mobilePhone !== "" && (
              <DivContainer>
                <Image
                  src={mobilePhoneIcon}
                  alt={t("MOBILE")}
                  title={t("MOBILE")}
                  styles={{ width: "18px", marginRight: "3px" }}
                />
                {data.mobilePhone}
              </DivContainer>
            )}
            {data?.phone !== null && data?.phone !== "" && (
              <DivContainer>
                <Image
                  src={phoneIcon}
                  alt={t("PHONE")}
                  title={t("PHONE")}
                  styles={{ width: "18px", marginRight: "3px" }}
                />
                {data.phone}
              </DivContainer>
            )}
          </ButtonContainer>
        </DivBackgroundFullOpacity>
      )}
      {data.status !== 1 && (
        <DivBackgroundLowOpacity>
          <ButtonContainer>
            {data?.email !== null && data?.email !== "" && (
              <>
                <DivContainer>
                  <Image
                    src={emailIcon}
                    alt={t("EMAIL")}
                    title={t("EMAIL")}
                    styles={{ width: "18px", marginRight: "3px" }}
                  />
                  {data.email}
                </DivContainer>
                <br></br>
              </>
            )}
            {data?.mobilePhone !== null && data?.mobilePhone !== "" && (
              <DivContainer>
                <Image
                  src={mobilePhoneIcon}
                  alt={t("MOBILE")}
                  title={t("MOBILE")}
                  styles={{ width: "18px", marginRight: "3px" }}
                />
                {data.mobilePhone}
              </DivContainer>
            )}
            {data?.phone !== null && data?.phone !== "" && (
              <DivContainer>
                <Image
                  src={phoneIcon}
                  alt={t("PHONE")}
                  title={t("PHONE")}
                  styles={{ width: "18px", marginRight: "3px" }}
                />
                {data.phone}
              </DivContainer>
            )}
          </ButtonContainer>
        </DivBackgroundLowOpacity>
      )}
    </>
  );
};

export default withTranslation()(Communication);
